import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories, siteInfo, stats } from "@/mocks/gossipData";

export default function HomeHero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const onSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/gossip?q=${encodeURIComponent(q)}` : "/gossip");
  };

  return (
    <section className="relative w-full overflow-hidden" aria-label="首屏介绍">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20abstract%20collage%20of%20warm%20cream%20paper%20texture%20with%20terracotta%20and%20amber%20organic%20shapes%2C%20subtle%20halftone%20dots%20and%20grainy%20editorial%20magazine%20background%2C%20soft%20gradient%20light%2C%20elegant%20minimal%20composition%2C%20no%20text&width=1600&height=900&seq=gt-hero-2026-a1&orientation=landscape"
          alt="暖色调编辑风抽象背景，象征吃瓜资讯的整理与盘点"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/85" />

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
        <span className="flex items-center gap-2 rounded-full border border-background-100/30 bg-background-100/10 px-4 py-1.5 text-xs font-label text-background-100 backdrop-blur">
          <i className="ri-sparkling-2-line" aria-hidden="true" />
          娱乐吃瓜 · 每日精选盘点
        </span>

        <h1 className="mt-6 flex flex-col items-center gap-3">
          <span className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            {siteInfo.name}
          </span>
          <span className="max-w-3xl text-lg font-light text-background-100 md:text-2xl">
            {siteInfo.slogan}
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          综艺名场面、剧集看点、网络热议、红毯造型与赛场高光，全部整理成一份份看得完的合集，省去你四处翻找的时间。
        </p>

        <form
          onSubmit={onSearch}
          className="mt-8 flex w-full max-w-2xl flex-col items-stretch gap-2 rounded-2xl border border-background-100/25 bg-background-50/95 p-2 sm:flex-row sm:items-center sm:rounded-full"
          role="search"
        >
          <span className="hidden h-9 w-9 shrink-0 items-center justify-center text-foreground-500 sm:flex">
            <i className="ri-search-line text-lg" aria-hidden="true" />
          </span>
          <label htmlFor="hero-search" className="sr-only">
            搜索吃瓜合集
          </label>
          <input
            id="hero-search"
            name="q"
            type="search"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索合集、话题或关键词，例如「综艺名场面」"
            className="h-11 w-full flex-1 bg-transparent px-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 sm:px-1"
          />
          <button
            type="submit"
            className="h-11 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            搜索合集
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/gossip?category=${cat.slug}`}
              className="whitespace-nowrap rounded-full border border-background-100/25 px-4 py-1.5 text-xs font-label text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300 cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <dl className="mt-12 grid w-full max-w-4xl grid-cols-2 gap-6 border-t border-background-100/20 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-1.5">
              <dt className="order-2 text-xs text-background-300">{item.label}</dt>
              <dd className="order-1 font-heading text-2xl text-background-50 md:text-3xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}